import React, { useContext, useEffect, useState } from "react";
import shortid from "shortid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import { ManageLoadPostContext } from "../..";
import useHttp from "../../../../../hooks/useHttp";
import { APROXIMATE_LOAD_PRICE_URL } from "../../../../../utils/api-ends";
import Alert from "@mui/material/Alert";
import { LOAD_TYPES } from "../../../../../utils/generalData";

const AdditionalInfo = ({ nonFieldErrors, additionalInfoRef }) => {
  const [loadPostState, loadPostContextDispatch] = useContext(
    ManageLoadPostContext
  );
  const loadPostInfo = loadPostState.loadPostInfo;
  const errorMessages = loadPostState.loadPostInfoErrors;
  const { sendRequests: aproximatePriceRequest } = useHttp();
  const [aproximatePrice, setAproximatePrice] = React.useState({});
  let distanceKm =
    loadPostState?.addressInformationMapInfo?.distance?.value / 1000;
  const [totalLoad, setTotalLoad] = useState(1);

  useEffect(() => {
    if (loadPostInfo?.load_type === "pallet")
      setTotalLoad(loadPostInfo?.pallet_list?.length);
    if (loadPostInfo?.load_type === "barrel")
      setTotalLoad(loadPostInfo?.barrel_list?.length);
    if (loadPostInfo?.load_type === "stones")
      setTotalLoad(loadPostInfo?.stones_list?.length);
    if (loadPostInfo?.load_type === "sand")
      setTotalLoad(loadPostInfo?.sand_list?.length);
    if (loadPostInfo?.load_type === "laterite")
      setTotalLoad(loadPostInfo?.laterite_list?.length);
    if (loadPostInfo?.load_type === "vehicle")
      setTotalLoad(loadPostInfo?.vehicle_list?.length);
  }, [
    loadPostInfo?.pallet_list,
    loadPostInfo?.barrel_list,
    loadPostInfo?.stones_list,
    loadPostInfo?.sand_list,
    loadPostInfo?.laterite_list,
    loadPostInfo?.vehicle_list,
    loadPostInfo?.load_type,
  ]);

  const onChange = (e) => {
    const { name, value } = e.target;
    if (name === "pickup_date") {
      loadPostContextDispatch({
        type: "ON_CHANGE_LOAD_POST_INFO",
        payload: { name: "delivery_date", value: "" },
      });
    }

    loadPostContextDispatch({
      type: "ON_CHANGE_LOAD_POST_INFO",
      payload: { name, value },
    });
  };

  // Approximate Load Feed price
  useEffect(() => {
    const response = (data) => {
      loadPostContextDispatch({
        type: "MINIMUM_PRICE_TO_PAY",
        payload: data?.basic_price,
      });
      setAproximatePrice(data);
    };

    aproximatePriceRequest(
      {
        url: APROXIMATE_LOAD_PRICE_URL,
        method: "get",
        params: {
          load_type: loadPostInfo.load_type,
          country: loadPostInfo.destination_country,
          state: loadPostInfo.destination_state,
          distance: parseInt(distanceKm),
          total_load: totalLoad,
        },
      },
      response
    );
  }, [
    loadPostInfo?.load_type,
    loadPostInfo?.destination_country,
    loadPostInfo?.destination_state,
    distanceKm,
    totalLoad,
  ]);

  // Show or hide error messages on mouse enter or leave
  const showErrorMessage = (e) =>
    e.currentTarget.setAttribute("show-tittle", "true");
  const hideErrorMessage = (e) =>
    e.currentTarget.setAttribute("show-tittle", "false");

  return (
    <section id="load-post-load-info" ref={additionalInfoRef}>
      <div className="container theme-section" id="load-type-singel-section">
        <div className="row">
          <div className="col-md-4">
            <div className="input-box-area mb-0" single-labe="true">
              <label> Load Type </label>
              <Select
                name="load_type"
                value={loadPostInfo.load_type}
                onChange={onChange}
                displayEmpty
                fullWidth
                className="mui-select-field-without-label"
                inputProps={{ "aria-label": "Without label" }}
              >
                {LOAD_TYPES[loadPostInfo.destination_country]?.map((item) => (
                  <MenuItem value={item.value}>{item.label}</MenuItem>
                ))}
              </Select>

              {errorMessages.load_type?.length > 0 && (
                <div
                  className="error"
                  show-tittle="false"
                  onMouseEnter={showErrorMessage}
                  onMouseLeave={hideErrorMessage}
                >
                  <i className="fa-solid fa-circle-exclamation"></i>
                  {errorMessages.load_type?.map((error, index) => (
                    <p key={shortid.generate()}>{error}</p>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="container theme-section">
        {nonFieldErrors?.map((item) => (
          <Alert key={shortid.generate()} severity="error" className="mb-3">
            {item}
          </Alert>
        ))}

        <div className="row">
          <div className="col-md-4">
            <div className="information-field border-0">
              <div className="input-box-area" single-labe="true">
                <label> Payment Type </label>
                <Select
                  name="payment_type"
                  value={loadPostInfo.payment_type}
                  onChange={onChange}
                  fullWidth
                  displayEmpty
                  className="mui-select-field-without-label"
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem value="prepaid">Prepaid</MenuItem>
                  <MenuItem value="postpaid">Post Paid (MoMo, CashApp, Zelle)</MenuItem>
                </Select>
                <p style={{ fontSize: "14px", color: "grey" }}>
                  Contact Customer service when using "Post Paid"
                </p>

                {errorMessages.payment_type?.length > 0 && (
                  <div
                    className="error"
                    show-tittle="false"
                    onMouseEnter={showErrorMessage}
                    onMouseLeave={hideErrorMessage}
                  >
                    <i className="fa-solid fa-circle-exclamation"></i>
                    {errorMessages.payment_type?.map((error, index) => (
                      <p key={shortid.generate()}>{error}</p>
                    ))}
                  </div>
                )}
              </div>

              <div className="input-box-area" single-labe="true">
                <label>
                  {" "}
                  Load Price <span className="opacity-50">(USD)</span>{" "}
                </label>
                <input
                  type="number"
                  placeholder="Load Price"
                  name="price_to_pay_carrier"
                  value={loadPostInfo.price_to_pay_carrier}
                  onChange={onChange}
                />

                {errorMessages.price_to_pay_carrier?.length > 0 && (
                  <div
                    className="error"
                    show-tittle="false"
                    onMouseEnter={showErrorMessage}
                    onMouseLeave={hideErrorMessage}
                  >
                    <i className="fa-solid fa-circle-exclamation"></i>
                    {errorMessages.price_to_pay_carrier?.map((error, index) => (
                      <p key={shortid.generate()}>{error}</p>
                    ))}
                  </div>
                )}

                <p style={{ fontSize: "14px", color: "grey" }}>
                  Aproximate Basic Price: {aproximatePrice?.basic_price} USD
                </p>

                <p style={{ fontSize: "14px", color: "grey" }}>
                  Aproximate Medium Price: {aproximatePrice?.medium_price} USD
                </p>
                <p style={{ fontSize: "14px", color: "grey" }}>
                  Aproximate Higher Price: {aproximatePrice?.higher_price} USD
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="information-field border-0">
              <div className="input-box-area" single-labe="true">
                <label> Pickup Date </label>
                <input
                  type="date"
                  placeholder="Pickup Date"
                  name="pickup_date"
                  value={loadPostInfo.pickup_date}
                  min={
                    new Date(
                      new Date().getTime() -
                        new Date().getTimezoneOffset() * 60000
                    )
                      .toISOString()
                      .split("T")[0]
                  }
                  onChange={onChange}
                />

                {errorMessages.pickup_date?.length > 0 && (
                  <div
                    className="error"
                    show-tittle="false"
                    onMouseEnter={showErrorMessage}
                    onMouseLeave={hideErrorMessage}
                  >
                    <i className="fa-solid fa-circle-exclamation"></i>
                    {errorMessages.pickup_date?.map((error, index) => (
                      <p key={shortid.generate()}>{error}</p>
                    ))}
                  </div>
                )}
              </div>

              <div className="input-box-area" single-labe="true">
                <label> Delivery Date </label>
                <input
                  type="date"
                  placeholder="Delivery Date"
                  name="delivery_date"
                  value={loadPostInfo.delivery_date}
                  min={
                    loadPostInfo?.pickup_date ||
                    new Date(
                      new Date().getTime() -
                        new Date().getTimezoneOffset() * 60000
                    )
                      .toISOString()
                      .split("T")[0]
                  }
                  onChange={onChange}
                />

                {errorMessages.delivery_date?.length > 0 && (
                  <div
                    className="error"
                    show-tittle="false"
                    onMouseEnter={showErrorMessage}
                    onMouseLeave={hideErrorMessage}
                  >
                    <i className="fa-solid fa-circle-exclamation"></i>
                    {errorMessages.delivery_date?.map((error, index) => (
                      <p key={shortid.generate()}>{error}</p>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="information-field border-0">
              <div className="input-box-area" single-labe="true">
                <label> Additional Information </label>
                <textarea
                  placeholder="Additional Information"
                  name="additional_information"
                  value={loadPostInfo.additional_information}
                  onChange={onChange}
                ></textarea>

                {errorMessages.additional_information?.length > 0 && (
                  <div
                    className="error"
                    show-tittle="false"
                    onMouseEnter={showErrorMessage}
                    onMouseLeave={hideErrorMessage}
                  >
                    <i className="fa-solid fa-circle-exclamation"></i>
                    {errorMessages.additional_information?.map(
                      (error, index) => (
                        <p key={shortid.generate()}>{error}</p>
                      )
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default React.memo(AdditionalInfo);
